import React, { useContext } from 'react';
import { MyContext } from '../../context';

function Cancellation() {
  const { pageData } = useContext(MyContext);
  return (
    <section className="commonConditions">
      <div className="container">
        <div className="smallContainer">
          <h1>{pageData?.cancellationAndRefund?.header}</h1>
          {pageData?.cancellationAndRefund?.dataArray?.map?.((item, index) => (
            <div
              key={index}
              style={{ paddingBottom: '10px', paddingTop: '10px' }}
            >
              <h2>{item?.subHeader}</h2>
              <p style={{ padding: '0px' }}>{item?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Cancellation;
